/* Initializers Services */
export * from './firebase.service.js';

/* Regular Services */
export * from './localStorage.service.js';
export * from './matches.service.js';
export * from './ranking.service.js';
export * from './settings.service.js';



// WEBPACK FOOTER //
// ./src/services/index.js